module.exports = __webpack_public_path__ + "img/5.1d618706.jpg";